import classNames from 'classnames';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import BusinessReviews from '../BusinessReviews/BusinessReviews';
import { ChatContainer } from '../ChatContainer/ChatContainer';
import { FAQPhoneContainer } from '../FAQPhoneContainer/FAQPhoneContainer';
import { Separator } from '../Separator/Separator';
import style from './PreFooter.module.scss';

interface PreFooterProps {
  hideHelpSection?: boolean;
}

const PreFooterComponent: FC<PreFooterProps> = ({ hideHelpSection }) => {
  const { t } = useTranslation();
  const { stylesheet: { contact: { onlyMentionPartnerInFooter } } } = useContext(StylesheetContext);

  return (
    <div className={style.container}>
      {!onlyMentionPartnerInFooter && (
        <div className={style.titleSectionWrapper}>
          <div>
            <h2>{t('footer:title')}<br /> <span className={style.titleHighlight}>Guidion</span>.</h2>
          </div>

          <Separator classes={classNames(style.permanentSeparator, style.firstSeparator)} />

          <div className={style.businessReviews}>
            <BusinessReviews />
          </div>
        </div>
      )}
      {
        !hideHelpSection && (
          <>
            {!onlyMentionPartnerInFooter && <Separator classes={style.mobileOnlySeparator}/>}
            <h2>{t('footer:questions')}</h2>
            <div className={style.contactOptions}>
              <ChatContainer/>
              <FAQPhoneContainer/>
            </div>
            <Separator classes={style.permanentSeparator} />
          </>
        )
      }
    </div>
  );
};

export const PreFooter = React.memo(PreFooterComponent);
